import { loadFromLocalStorage } from '@databases/localStorage';
import * as React from 'react';
import { contantAuthentication } from '@contants/index';

export const useRole = () => {
  const user = JSON.parse(loadFromLocalStorage(contantAuthentication.DATA_AUTH))?.user || null;

  const role = user?.role || [];
  const isWebWorker = role == 0;
  const isWebManager = role == 1;
  const isWebAdmin = role == 2;
  const isWebSuperAdmin = role == 101915236;

  return {
    isWebWorker,
    isWebAdmin,
    isWebManager,
    isWebSuperAdmin
  };
};
